(function() {
  'use strict';

  var SELECTOR_SECTION = '[data-section-type="hero-banner"]',
    SELECTOR_VIDEOS = '.hero-banner__videos',
    SELECTOR_VIDEO = '.hero-banner__bg-video',
    SELECTOR_PREV = '.hero-banner__nav-btn--prev',
    SELECTOR_NEXT = '.hero-banner__nav-btn--next',
    SELECTOR_DOT = '.hero-banner__dot',
    SELECTOR_ROBOT = '[data-robot]';

  var LEAF_COUNT = 81,
    CLEAN_RADIUS = 70,
    SUCK_ACCEL = 0.08,
    DAMPING = 0.97,
    LERP_FACTOR = 0.18,
    ROTATION_SPEED = 0.12,
    DRIFT_INTERVAL = 0.004,
    MIN_DIST = 50,
    START_DELAY = 3000;

  var LEAF_PATHS = [
    'M981.504 556.032l-22.528 8.192c-93.184 34.304-155.648 87.552-185.344 158.208-22.528 52.224-17.408 95.744-17.408 95.744l4.096 31.232-22.016-22.528c-42.496-44.544-92.16-61.44-146.432-50.176-40.96 8.704-69.632 30.208-69.632 30.208l-0.512 0.512v182.272h-20.992v-189.44c-83.456-55.296-222.72 15.872-224.256 16.896l-19.968 10.752 5.12-22.016c36.864-161.28-195.584-247.296-198.144-248.32l-33.792-12.288 34.816-7.68c82.432-18.432 57.344-148.992 57.344-150.528l-3.584-17.408 16.896 5.12c33.28 10.24 60.416 9.216 80.896-3.072 29.184-17.408 35.84-51.2 35.84-51.712l9.216-48.128 11.264 47.616c7.68 32.256 59.904 70.656 89.088 89.088 25.6-77.824-27.136-204.8-27.648-206.336l-7.168-17.408 18.432 3.072c125.952 19.456 159.232-122.88 160.256-129.024l8.704-39.424 11.264 38.912c19.968 67.072 48.64 109.056 86.016 125.44 37.376 15.872 69.12 0.512 69.632 0.512l27.136-13.312-12.8 27.136c-35.84 75.264-31.232 167.936-27.136 206.848l106.496-95.232 5.12 15.36c22.528 69.12 124.416 49.152 124.928 48.64l18.944-4.096-7.168 17.92c-42.496 111.104 40.448 155.136 44.032 156.672l20.992 11.776z'
  ];
  var LEAF_SHAPES;

  var LEAF_COLORS = [
    { fill: 'rgba(180,130,60,0.88)', stroke: 'rgba(120,80,30,0.82)' },
    { fill: 'rgba(160,60,40,0.85)', stroke: 'rgba(100,30,20,0.80)' },
    { fill: 'rgba(200,140,50,0.82)', stroke: 'rgba(130,80,20,0.78)' },
    { fill: 'rgba(78,49,26,0.80)', stroke: 'rgba(50,30,15,0.75)' }
  ];

  function shouldRunParticles() {
    return typeof window.Path2D === 'function' &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getLeafShapes() {
    return LEAF_SHAPES ||
      (LEAF_SHAPES = LEAF_PATHS.map(function(data) { return new window.Path2D(data); }));
  }

  function Leaf(w, h) {
    this.init(w, h);
  }

  Leaf.prototype.init = function(w, h) {
    var edge = Math.random() < 0.7;
    var margin = 30;

    if (edge) {
      var edgeType = Math.floor(Math.random() * 4);
      if (edgeType === 0) {
        this.x = Math.random() * w;
        this.y = -margin;
      } else if (edgeType === 1) {
        this.x = w + margin;
        this.y = Math.random() * h;
      } else if (edgeType === 2) {
        this.x = Math.random() * w;
        this.y = h + margin;
      } else {
        this.x = -margin;
        this.y = Math.random() * h;
      }
    } else {
      this.x = Math.random() * w;
      this.y = Math.random() * h;
    }

    this.vx = (Math.random() - 0.5) * 0.8;
    this.vy = (Math.random() - 0.5) * 0.8;
    this.scale = 1;
    this.rotation = Math.random() * Math.PI * 2;
    this.rotationSpeed = (Math.random() - 0.5) * 0.03;
    this.shapeIndex = Math.floor(Math.random() * LEAF_PATHS.length);
    this.colorIndex = Math.floor(Math.random() * LEAF_COLORS.length);
    this.state = 'free';
    this.alpha = 0.7 + Math.random() * 0.3;
  };

  Leaf.prototype.update = function(rx, ry, shouldAttract, w, h) {
    var dx = rx - this.x;
    var dy = ry - this.y;
    var dist = Math.sqrt(dx * dx + dy * dy);

    if (this.state === 'sucked') {
      if (dist > 1) {
        var n = 1 / dist;
        this.vx += dx * n * SUCK_ACCEL;
        this.vy += dy * n * SUCK_ACCEL;
      }
      if (dist < CLEAN_RADIUS) {
        this.scale -= 0.08;
        if (this.scale <= 0) {
          this.init(w, h);
          return;
        }
      }
    } else {
      this.vx += (Math.random() - 0.5) * DRIFT_INTERVAL;
      this.vy += (Math.random() - 0.5) * DRIFT_INTERVAL;
      if (shouldAttract && dist < MIN_DIST) {
        var p = 0.02;
        this.vx += dx * p * (1 / dist);
        this.vy += dy * p * (1 / dist);
      }
    }

    this.vx *= DAMPING;
    this.vy *= DAMPING;
    this.x += this.vx;
    this.y += this.vy;
    this.rotation += this.rotationSpeed * 0.5;

    if (shouldAttract && dist < CLEAN_RADIUS) {
      this.state = 'sucked';
    }

    var margin = 60;
    if (this.x < -margin || this.x > w + margin || this.y < -margin || this.y > h + margin) {
      if (this.state !== 'sucked') {
        this.init(w, h);
      }
    }
  };

  Leaf.prototype.draw = function(ctx) {
    if (this.scale <= 0) return;

    var color = LEAF_COLORS[this.colorIndex];
    var scale = 0.0234;
    ctx.save();
    ctx.translate(this.x, this.y);
    ctx.rotate(this.rotation);
    ctx.scale(this.scale * scale, this.scale * scale);
    ctx.globalAlpha = this.alpha;

    var path = getLeafShapes()[this.shapeIndex];
    ctx.fillStyle = color.fill;
    ctx.strokeStyle = color.stroke;
    ctx.lineWidth = 0.08;
    ctx.fill(path);
    ctx.stroke(path);

    ctx.restore();
  };

  function resizeCanvas(section) {
    var canvas = section._heroBanner.canvas;
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    var rect = section.getBoundingClientRect();
    var dpr = Math.min(window.devicePixelRatio || 1, 2);

    canvas.width = Math.floor(rect.width * dpr);
    canvas.height = Math.floor(rect.height * dpr);
    canvas.style.width = rect.width + 'px';
    canvas.style.height = rect.height + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    section._heroBanner.canvasWidth = rect.width;
    section._heroBanner.canvasHeight = rect.height;
  }

  function initDirtLayer(section) {
    var canvas = section.querySelector('[data-canvas]');
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    if (!ctx) return;

    var count = window.matchMedia('(pointer: coarse)').matches ? 36 : LEAF_COUNT;
    if ((navigator.hardwareConcurrency || 2) < 4) count = 24;
    var leaves = [];

    function buildLeaves() {
      var rect = section.getBoundingClientRect();
      leaves = [];
      for (var i = 0; i < count; i++) {
        leaves.push(new Leaf(rect.width, rect.height));
      }
    }

    function resize() {
      resizeCanvas(section);
      buildLeaves();
    }

    section._heroBanner = section._heroBanner || {};
    section._heroBanner.canvas = canvas;
    section._heroBanner.ctx = ctx;
    section._heroBanner.leaves = leaves;

    if (count > 0) {
      resize();
      section._heroBanner.leaves = leaves;
      window.addEventListener('resize', resize);
    }
  }

  function initRobot(section) {
    var robot = section.querySelector(SELECTOR_ROBOT);
    if (!robot) return;

    section._heroBanner = section._heroBanner || {};
    var hero = section._heroBanner;
    var rect = section.getBoundingClientRect();

    var state = {
      targetX: rect.width / 2,
      targetY: rect.height / 2,
      x: rect.width / 2,
      y: rect.height / 2,
      angle: 0,
      hasInput: false,
      lastInputAt: 0
    };

    hero.robot = robot;
    hero.robotState = state;

    hero.updateRobot = function() {
      var dx = state.targetX - state.x;
      var dy = state.targetY - state.y;
      state.x += dx * LERP_FACTOR;
      state.y += dy * LERP_FACTOR;

      var moving = Math.abs(dx) > 0.5 || Math.abs(dy) > 0.5;
      if (moving) {
        var da = Math.atan2(dy, dx) * (180 / Math.PI);
        var delta = ((da - state.angle + 540) % 360) - 180;
        state.angle += delta * ROTATION_SPEED;
      }

      robot.style.transform = 'translate3d(' + state.x + 'px, ' + state.y + 'px, 0) translate(-50%, -50%) rotate(' + state.angle + 'deg)';
    };
    hero.updateRobot();
  }

  function initPointerFollow(section) {
    var hero = section._heroBanner;
    if (!hero || !hero.robotState) return;

    var state = hero.robotState;

    function setTarget(x, y) {
      var r = section.getBoundingClientRect();
      state.targetX = Math.max(20, Math.min(r.width - 20, x - r.left));
      state.targetY = Math.max(20, Math.min(r.height - 20, y - r.top));
    }

    function handlePointerInput(e) {
      if (!e.isPrimary) return;
      setTarget(e.clientX, e.clientY);
      state.hasInput = true;
      state.lastInputAt = window.performance.now();
      if (hero.startAnimation) hero.startAnimation();
    }

    section.addEventListener('pointerdown', handlePointerInput);
    section.addEventListener('pointermove', handlePointerInput);

  }

  function initVisibilityObserver(section, animateParticles) {
    var hero = section._heroBanner;
    if (!hero || typeof window.IntersectionObserver === 'undefined') return;

    var rafId = null;
    var startTime = Date.now();
    var isVisible = false;

    function loop() {
      if (!isVisible || !hero.robotState || !hero.robotState.hasInput) {
        rafId = null;
        return;
      }

      if (hero.updateRobot) hero.updateRobot();

      var state = hero.robotState;
      var leaves = hero.leaves;
      var ctx = hero.ctx;
      var w = hero.canvasWidth;
      var h = hero.canvasHeight;

      if (state && ctx && leaves && leaves.length > 0 && hero.carousel && hero.carousel.particlesEnabled) {
        ctx.clearRect(0, 0, w, h);
        var shouldAttract = state.hasInput && (Date.now() - startTime > START_DELAY);

        for (var i = 0; i < leaves.length; i++) {
          leaves[i].update(state.x, state.y, shouldAttract, w, h);
          leaves[i].draw(ctx);
        }
      } else if (ctx && w && h) {
        ctx.clearRect(0, 0, w, h);
      }

      if (window.performance.now() - state.lastInputAt > 1000) {
        state.hasInput = false;
        rafId = null;
        return;
      }

      rafId = window.requestAnimationFrame(loop);
    }

    function start() {
      if (!animateParticles || !isVisible || rafId !== null) return;
      rafId = window.requestAnimationFrame(loop);
    }

    function stop() {
      if (rafId !== null) {
        window.cancelAnimationFrame(rafId);
        rafId = null;
      }
    }

    var observer = new window.IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        var carousel = hero.carousel;
        if (entry.isIntersecting) {
          isVisible = true;
          if (hero.robotState && hero.robotState.hasInput) start();
          if (carousel && carousel.motionPlaying) {
            goToSlide(section, carousel.currentIndex);
          }
        } else if (!entry.isIntersecting) {
          isVisible = false;
          stop();
          if (carousel) {
            carousel.videos.forEach(function(video) { video.pause(); });
          }
        }
      });
    }, { threshold: 0.01 });

    observer.observe(section);
    hero.startAnimation = start;
    hero.visibilityObserver = observer;
    hero.stopAnimation = stop;
  }

  function getCarouselState(section) {
    if (!section._heroBanner) section._heroBanner = {};

    if (!section._heroBanner.carousel) {
      var videosContainer = section.querySelector(SELECTOR_VIDEOS);
      var videos = videosContainer ? videosContainer.querySelectorAll(SELECTOR_VIDEO) : [];
      var dots = section.querySelectorAll(SELECTOR_DOT);
      var videoParticleSettings = [];

      videos.forEach(function(video) {
        var slide = video.closest('[data-enable-particles]');
        videoParticleSettings.push(slide && slide.dataset.enableParticles === 'true');
        video.addEventListener('playing', function() {
          video.classList.add('is-playing');
        });
      });

      section._heroBanner.carousel = {
        currentIndex: 0,
        totalSlides: videos.length,
        videos: videos,
        dots: dots,
        videoParticleSettings: videoParticleSettings,
        motionPlaying: !window.matchMedia('(prefers-reduced-motion: reduce)').matches,
        particlesEnabled: videoParticleSettings[0] === true
      };
    }

    return section._heroBanner.carousel;
  }

  function hydrateVideo(video) {
    if (!video || video.dataset.loaded === 'true') return;
    var slide = video.closest('.hero-banner__video-slide');
    var template = slide ? slide.querySelector('[data-hero-video-sources]') : null;
    if (!template) return;

    video.appendChild(template.content.cloneNode(true));
    video.dataset.loaded = 'true';
    video.load();
  }

  function playVideoAfterPoster(video) {
    var slide = video.closest('.hero-banner__video-slide');
    var poster = slide && slide.querySelector('.hero-banner__poster');
    var play = function() {
      if (slide && slide.style.display === 'none') return;
      hydrateVideo(video);
      video.muted = true;
      video.playsInline = true;
      video.play().catch(function() {});
    };
    if (!poster || poster.complete) play();
    else poster.addEventListener('load', play, { once: true });
  }

  function syncRobotVisibility(section) {
    var hero = section._heroBanner;
    var carousel = hero ? hero.carousel : null;
    if (!carousel || !hero.robot) return;

    hero.robot.classList.toggle(
      'hero-banner__robot--hidden',
      !carousel.particlesEnabled
    );
  }

  function goToSlide(section, index) {
    var hero = section._heroBanner;
    var carousel = hero.carousel;
    if (!carousel || carousel.totalSlides === 0) return;

    if (index < 0) index = carousel.totalSlides - 1;
    if (index >= carousel.totalSlides) index = 0;

    carousel.currentIndex = index;

    carousel.dots.forEach(function(dot, i) {
      dot.classList.toggle('hero-banner__dot--active', i === index);
      dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
    });

    carousel.videos.forEach(function(video, i) {
      var slide = video.closest('.hero-banner__video-slide');
      if (i === index) {
        if (slide) slide.style.display = 'block';
        if (carousel.motionPlaying) {
          playVideoAfterPoster(video);
        }
      } else {
        if (slide) slide.style.display = 'none';
        video.pause();
      }
    });

    if (carousel.videoParticleSettings && carousel.videoParticleSettings[index] !== undefined) {
      carousel.particlesEnabled = carousel.videoParticleSettings[index];
    }
    syncRobotVisibility(section);

    section.dataset.currentIndex = index;
  }

  function nextSlide(section) {
    var carousel = getCarouselState(section);
    goToSlide(section, carousel.currentIndex + 1);
  }

  function prevSlide(section) {
    var carousel = getCarouselState(section);
    goToSlide(section, carousel.currentIndex - 1);
  }

  function initCarousel(section) {
    var videosContainer = section.querySelector(SELECTOR_VIDEOS);
    if (!videosContainer) return;

    var carousel = getCarouselState(section);
    if (carousel.totalSlides === 0) return;

    goToSlide(section, 0);

    if (carousel.totalSlides <= 1) return;

    var prevBtn = section.querySelector(SELECTOR_PREV);
    var nextBtn = section.querySelector(SELECTOR_NEXT);

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        prevSlide(section);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        nextSlide(section);
      });
    }

    carousel.dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() {
        goToSlide(section, i);
      });
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function() {
    document.querySelectorAll(SELECTOR_SECTION).forEach(function(section) {
      initRobot(section);
      var animateParticles = shouldRunParticles();
      initCarousel(section);
      initVisibilityObserver(section, animateParticles);
      if (animateParticles) {
        initPointerFollow(section);
        initDirtLayer(section);
      }
    });
  });

})();
